import React from 'react';
import PropTypes from 'prop-types';
import {Heading} from './Heading';
import {ContentWrapper} from './ContentWrapper';
import {Instruction} from './Instruction';
import {InstructionBlock} from './InstructionBlock';
import {HintContainer} from './HintContainer';
import {HintBlock} from './HintBlock';
import {EmptyBlock} from './EmptyBlock';
import {EquipmentBlock} from './EquipmentBlock';
import {Equipment} from './Equipment';

import './style.scss';

export function Content(props) {
  return (
    <ContentWrapper className='ps_content'>
      <InstructionBlock className='ps_content_instruction'>
        <Heading className='ps_content_instruction_heading' />
        <Instruction className='ps_content_instruction_content' />
        <HintContainer>
          <HintBlock />
        </HintContainer>
        <EmptyBlock className='ps_content_instruction_emptyArea' />
      </InstructionBlock>
      <EquipmentBlock className='ps_content_equipmentBlock'
        pluggedIn={props.pluggedIn}
        interactionProps={props.interactionProps}
      >
        <Equipment
          className='ps_content_equipmentBlock_equipment'
          togglePower={props.togglePower}
          settingsData={props.settingsData}
          setTimer={props.setTimer}
          setVoltage={props.setVoltage}
          setCurrent={props.setCurrent}
          cablesData={props.cablesData}
          onClickStart={props.onClickStart}
          onClickStop={props.onClickStop}
          interactionProps={props.interactionProps}
          alert={props.alert}
        />
      </EquipmentBlock>
    </ContentWrapper>
  );
}

Content.propTypes = {
  ...Equipment.propTypes,
};
Content.defualtProps = {};
